// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: ':id/new-tax-bill-payment',
        component: () =>
            import(/* webpackChunkName: "tax-compliance.tax-bill-payments" */ '@/pages/[organisation]/tax-compliance/tax-bill-payments/tax-bill-payment/new.vue'),
        name: 'tax-compliance.tax-bill-payments.create-tax-bill-payment',
        meta: {
            loginRequired: true,
            permission: 'access.tax-compliance.create-tax-bill-payment',
        },
    },
    {
        path: ':id/tax-bill-payments',
        component: () =>
            import(/* webpackChunkName: "tax-compliance.tax-bill-payments" */ '@/pages/[organisation]/tax-compliance/tax-bill-payments/tax-bill-payments.vue'),
        name: 'tax-compliance.tax-bill-payments.search-tax-bill-payments',
        meta: {
            loginRequired: true,
            permission: 'access.tax-compliance.view-tax-bill-payments',
        },
    },
    {
        path: ':id/tax-bill-payments/:paymentId/redo-payment',
        component: () =>
            import(/* webpackChunkName: "tax-compliance.tax-bill-payments" */ '@/pages/[organisation]/tax-compliance/tax-bill-payments/redo-tax-bill-payment.vue'),
        name: 'tax-compliance.tax-bill-payments.redo-tax-bill-payment',
        meta: {
            loginRequired: true,
            permission: 'access.tax-compliance.create-tax-bill-payment',
        },
    },
];
